export const IsNaNOrUndefined = (num: number) =>  Number.isNaN(num) || !Boolean(num);
